module.exports = __webpack_public_path__ + "static/media/AB_W1_2.6c4bd6a1.jpg";